import NagraSettingsApi from 'services/nagra/SettingsApi'

/**
 * Deals with Playback requirements (session creation, tracking etc)
 */
export default class SettingsApi extends NagraSettingsApi {
    constructor(config, otherApis = {}) {
        super(config, otherApis)
    }
}
